import BaseService from './BaseService'

type Entity = {
  entityType: 'COMPANY' | 'LOCATION'
  entityId: string
}
class InternalToolsService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl, true)
  }

  updateLead = body => this.requests.put('/firstpromoter/lead', body)

  removePromoterForCompany = companyId => this.requests.post(`/firstpromoter/${companyId}/remove-promoter`, {})

  createPaymentIntent = body => this.requests.post(`/billing/payment-intent`, body)

  getDowngradableAgencyPlan = companyId => this.requests.get(`/billing/agency-plan/${companyId}/downgradable-plan`)

  downgradeAgencyPlan = body => this.requests.post('/billing/agency-plan/downgrade', body)

  getWaitTime = () => this.requests.get('/freshwork/chat/wait-time')

  defaultPaymentMethod = (params: Entity) =>
    this.requests.get('/billing/payment-method', { params: { ...params, defaultOnly: true } })

  getHipaaDetails = companyId => this.requests.get(`/compliance/get-hipaa-detail/${companyId}`)

  searchPartners = filter => this.requests.post(`/partners/search`, filter)

  addOrUpdatePartner = payload => this.requests.post('/partners/update', payload)

  deletePartner = partnerId => this.requests.delete(`/partners/${partnerId}`)

  addPartnerContact = payload => this.requests.post('/partners/add-contact', payload)

  sendEmail = payload => this.requests.post('/partners/email', payload)

  getStripeCustomer = (params: Entity) => this.requests.get('/billing/customer', { params })

  addCard = payload => this.requests.post('/billing/payment-method/card', payload)

  getCompanyBillingInfo = companyId => this.requests.get(`/billing/company-info/${companyId}`)

  checkOverused = (companyId: string) => this.requests.post(`/billing/company/${companyId}/check-overused`, {})

  locationTransferRequest = body => this.requests.post('/location-transfers', body)

  ejectLocationRequest = body => this.requests.post('/location-transfers/eject', body)

  fetchEjectRequests = params => this.requests.get('/location-transfers/eject', { params })

  locationTransferRequestsFetch = params => this.requests.get(`/location-transfers/requests`, { params })

  getOfferDetails = params => this.requests.get(`/billing/offers/custom-offers`, { params })

  getCompanyBillingPlan = companyId => this.requests.get(`/billing/company/${companyId}/plan`)

  retrieveOffers = (companyId: string, offerUrl: string) =>
    this.requests.get(`/billing/offers/custom-offers/${companyId}?offerUrl=${offerUrl}`)

  implementationCountCheck = userId => this.requests.get(`/billing/implementation-modal-count?userId=${userId}`)

  implementationCountUpdate = userId => this.requests.post(`/billing/implementation-modal-count`, { userId })

  fetchActiveAddOns = (companyId: string) => this.requests.get(`/billing/company/${companyId}/addons`)
  fetchPremiumSupport = (companyId: string) => this.requests.get(`/billing/premium-support-subscription`, { params: { companyId } })

}

const instance = new InternalToolsService(BaseService.servicesConfig.InternalTools)

export default instance
